import React from "react";
import "./WhyChooseUs.css";
import { FaStar, FaUsers, FaShieldAlt, FaBus } from "react-icons/fa";

const WhyChooseUs = () => {
  const points = [
    {
      icon: <FaStar />,
      title: "Top Rated Service",
      desc: "Trusted by thousands of happy travelers with excellent reviews.",
    },
    {
      icon: <FaUsers />,
      title: "Expert Team",
      desc: "Professional drivers and 24/7 customer support for hassle-free trips.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Safe & Secure",
      desc: "Your safety is our priority with fully sanitized & insured vehicles.",
    },
    {
      icon: <FaBus />,
      title: "Comfortable Rides",
      desc: "Spacious Tempo Travellers designed for long-distance comfort.",
    },
  ];

  return (
    <section className="whyChooseUs">
                  <h2>
            Why <span>Choose Us?</span>
          </h2>
      <div className="whyChooseUs-container">
        
        {/* Left Content */}
        <div className="whyChooseUs-left">

          <p>
            We make every journey stress-free, affordable, and enjoyable. Whether it’s a family trip, corporate travel, or a weekend getaway – we ensure a memorable experience.
          </p>

          <ul className="whyChooseUs-points">
            {points.map((item, index) => (
              <li key={index}>
                <span className="point-icon">{item.icon}</span>
                <div className="point-text">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Image */}
        <div className="whyChooseUs-right">
          <img
            src="https://images.91trucks.com/wp-content/uploads/2023/03/Force-Traveller-3050-removebg-preview.png"
            alt="Tempo Traveller"
          />
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
